module.exports = __webpack_public_path__ + "img/wizard.5ebec742.png";